import React from 'react';
import CTASection from '../../components/CTASection';
import SEO from '../components/SEO';
import ErrorBoundary from '../components/ErrorBoundary';
const ContactPage = () => {
  // Structured data for contact page
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Legacy Lab Financial',
    description: 'Ready to build your financial legacy? Contact us today to learn how we can help you achieve your financial goals.',
    url: 'https://legacylabfinancial.com/contact',
    mainEntity: {
      '@type': 'Organization',
      name: 'Legacy Lab Financial',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        url: 'https://link.builderspro.io/widget/form/Y62ZKJUTn6F3f3jyumwK'
      }
    }
  };
  return <>
      <SEO title="Contact" description="Ready to build your financial legacy? Contact us today to learn how we can help you achieve your financial goals." structuredData={structuredData} data-id="element-401" />
      <div className="py-16 px-4 text-center" data-id="element-402">
        <h1 className="text-4xl sm:text-5xl font-bold" data-id="element-403">
          Get in <span className="text-gradient" data-id="element-404">Touch</span>
        </h1>
        <p className="mt-6 max-w-3xl mx-auto text-lg text-gray-600" data-id="element-405">
          Ready to build your financial legacy? Contact us today to learn how we
          can help you achieve your financial goals.
        </p>
      </div>
      <ErrorBoundary data-id="element-406">
        <CTASection data-id="element-407" />
      </ErrorBoundary>
    </>;
};
export default ContactPage;